import { twMerge } from "@stereoagency/tailwind-config";
import React from "react";
import { Body, Heading } from "../../atoms";
export default function SectionHeader(param) {
    var title = param.title, subtitle = param.subtitle, className = param.className;
    return /*#__PURE__*/ React.createElement("div", {
        className: twMerge("w-full mx-auto max-w-sm", className)
    }, !!title && /*#__PURE__*/ React.createElement(Heading, {
        as: "h2",
        variant: "h2"
    }, title), !!subtitle && /*#__PURE__*/ React.createElement(Body, {
        variant: "md"
    }, subtitle));
}

//# sourceMappingURL=SectionHeader.js.map